import { Observable } from "rxjs";
import { UserModel } from "../models/user.model";
import { InjectionToken } from "@angular/core";
import { BaseResponseModel } from "../models/base-response.model";
import { AppVersionFeatureModel, AppVersionModel, SelectListItem } from "../models";
import { ResetPasswordModel, UserLoginModel } from "app/account/model";
import { ProductInventoryDataListModel } from "app/pages/product-inventory/models";
import { StoreUserDetailsModel } from "app/account/model/user-details-by-token.model";
import { RegistrationModel } from "app/account/model/registration.model";

export const USER_AUTHENTICATION_SERVICE = new InjectionToken("user authentication service");

export interface UserAuthInterface {

  //#region Fields

  get authenticatedUser(): UserModel;

  get authenticatedUserPermissions(): Array<string>;

  //#endregion

  //#region Methods

  /**
   * Login using code and password
   * @param Code User code
   * @param Password User password
   */
  login(Code: string, Password: string): Observable<BaseResponseModel<UserModel>>;

  /**
   * Send password reset link
   * @param email Email
   */
  sendPasswordResetLink(email: string): Observable<BaseResponseModel<string>>;

  /**
 * Reset user password
 * @param model Email
 */
  resetUserPassword(model: ResetPasswordModel): Observable<BaseResponseModel<UserModel>>;

  /**
 * Set the authenticated user details
 * @param user User
 */
  setAuthenticatedUser(user: UserModel, rememberMe: boolean): void;

  /**
   * Remember only the username/code for convenience on next visit.
   * Never store the password client-side, even encrypted.
   * @param code User code
   */
  setRememberedUsername(code: string): void;

  getRememberedUsername(): string | null;

  clearRememberedUsername(): void;

  /**
   * Check whether user has this permission or not
   * @param permissionName Permission name
   */
  hasPermission(permissionName: string): boolean;

  /**
 * Logout user account
 */
  logoutUser();

  clearSession();

  getDirecotryMetaDataList(): Observable<BaseResponseModel<SelectListItem>>;

  getAllProductInventory(searchText: string): Observable<BaseResponseModel<ProductInventoryDataListModel>>;

  getUserDetailsByToken(token: string): Observable<BaseResponseModel<StoreUserDetailsModel>>;

  insertUser(user: RegistrationModel): Observable<BaseResponseModel<string>>;

  isTokenExpired(token?: string);

  getCurrentAppVersion(): Observable<BaseResponseModel<AppVersionModel>>;

  getCurrentAppVersionFeatureByIf(id: string): Observable<BaseResponseModel<AppVersionFeatureModel>>;

  getAllAppVersions(): Observable<BaseResponseModel<AppVersionModel[]>>;

  getAllAppVersionFeatures(): Observable<BaseResponseModel<AppVersionFeatureModel[]>>;

  getSupportUserInfo(): Observable<BaseResponseModel<any>>;
  //#endregion
}